export enum RequestMode {
    GET = "GET",
    OPTIONS = "OPTIONS",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
}
